import modal from '@/utils/modal.js';
import { defineAsyncComponent } from 'vue';

const AvatarConfigurator = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "avatar-3d" */'./index.vue');
});

function openAvatarConfigurator (cfg) {
  console.log(cfg)
  // @TODO ensure merchant config initialized etc?
  const m = modal.create(AvatarConfigurator, true, { 
    disableCloseButton: true, 
    provide: {
      hideCancelButton: cfg?.hideCancelButton || false,
      doneText: cfg?.doneText,
    }
  });

  m.body.setAttribute('data-gmf', ''); // This signals that we are already handling this element (so for example elAttach wont mess with it)
  m.body.classList.add('gmf-popup-avatar-configurator');
}

export default openAvatarConfigurator;